import type { RecordTabFormProps } from "./shared";

/** Заглушка для item_type=eval_failure.
 *  Это сигнал «smoke-eval упал на конкретном предложении» — reviewer
 *  здесь НЕ переводит, а решает, нужен ли отдельный glossary-entry или
 *  открыть issue. Отдельный action-flow будет добавлен позже; пока —
 *  показываем readonly-карточку с контекстом из payload. */
export function EvalFailureView({ item, payload }: RecordTabFormProps) {
  const reason = payload.review_reason ?? "—";
  const examples = payload.examples ?? [];

  return (
    <section className="rf-section">
      <div className="rf-section__head">
        <span>Eval-failure (сигнал из smoke-теста)</span>
        <span className="mt-toolbar__sep" style={{ flex: 1 }} />
        <span
          className="mt-text-tight mt-muted"
          style={{ textTransform: "none", letterSpacing: 0 }}
        >
          escalation-only — здесь не переводим
        </span>
      </div>
      <div className="rf-section__body">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(160px, max-content) 1fr",
            gap: "4px 12px",
            fontSize: "var(--fs-sm)",
          }}
        >
          <div className="mt-mono mt-text-tight mt-muted">Причина</div>
          <div style={{ overflowWrap: "anywhere" }}>{reason}</div>
          {item.source_text && (
            <>
              <div className="mt-mono mt-text-tight mt-muted">
                Исходный текст
              </div>
              <div style={{ overflowWrap: "anywhere" }}>{item.source_text}</div>
            </>
          )}
          {item.candidate_text && (
            <>
              <div className="mt-mono mt-text-tight mt-muted">
                Машинный перевод
              </div>
              <div style={{ overflowWrap: "anywhere" }}>
                {item.candidate_text}
              </div>
            </>
          )}
          {item.source_key && (
            <>
              <div className="mt-mono mt-text-tight mt-muted">source_key</div>
              <div style={{ overflowWrap: "anywhere" }}>{item.source_key}</div>
            </>
          )}
        </div>
        {examples.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div
              className="mt-text-tight mt-muted"
              style={{ marginBottom: 6 }}
            >
              Примеры
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {examples.slice(0, 3).map((ex, i) => (
                <div
                  key={i}
                  className="rf-example"
                  style={{ fontSize: "var(--fs-sm)" }}
                >
                  {typeof ex === "string"
                    ? ex
                    : ((ex as { sentence?: string }).sentence ??
                      JSON.stringify(ex))}
                </div>
              ))}
            </div>
          </div>
        )}
        <div
          className="mt-text-tight mt-muted"
          style={{ marginTop: 14, fontStyle: "italic" }}
        >
          В будущем здесь будет flow «создать новый glossary-term из этой
          ошибки» или «открыть issue». Пока — Reject / Skip из dock'а.
        </div>
      </div>
    </section>
  );
}
